export const SUPER_ADMIN_USERNAME = 'admin';

export const USER_PRIVILEGES: API.UserPrivilege[] = [
  'manage-frontend-users',
  'manage-user-posts',
  'manage-user-comments',
  'edit-site-setting',
  'manage-recommendation',
  'edit-gallery-detail-ads',
];

export const isSuperAdminUsername = (username?: string) =>
  username?.toLowerCase() === SUPER_ADMIN_USERNAME;

export const decodePrivilegeBits = (bits?: string): API.UserPrivilege[] => {
  if (!bits) return [];
  return USER_PRIVILEGES.filter((_, index) => bits[index] === '1');
};

export const encodePrivilegeBits = (values: API.UserPrivilege[]) =>
  USER_PRIVILEGES.map((privilege) => (values.includes(privilege) ? '1' : '0')).join('');
